module.exports = __webpack_public_path__ + "media/images/icon-more-on@3x-2aedf3601dc2b47f53d1c107aa9a0ce8.png";